<template>
  <div @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div >Graduation Rate</div>
    <div>
      <div v-if="active">
        <apexchart width="400" type="radialBar" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div v-else class="content">
        <img src="https://images.squarespace-cdn.com/content/v1/5bf84b434611a034b52113b9/1580982334108-PNIFXACTKP4LJOKGXYR6/ke17ZwdGBToddI8pDm48kFyD7pzB8zoMIVY5aiUuFlp7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0jG2lbcDYBOeMi4OFSYem8DMb5PTLoEDdB05UqhYu-xbnSznFxIRsaAU-3g5IaylIg/PQC+Alums.JPG">
        <div class="text"><h1>Graduation Rate</h1></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
   return {
    active: false,
    series: [80],
    chartOptions: {
      chart: {
        type: "radialBar",
      }, 
      labels: ['Graduation Rate'],
      stroke: {
        lineCap: "round",
      },
      fill: {
        type: "gradient",
        gradient: {
        shade: "dark",
        type: "vertical",
        gradientToColors: ["#87D4F9"],
        stops: [0, 100]
        }
      },
    },
   }      
  },
  methods: {
    mouseOver: function() {
      this.active = true;
    }, 
    mouseLeave: function() {
      this.active = false;
    }
  },
};
</script>

<style scoped>
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.content {
  text-align: center;
  position: relative;
}

.img {
  object-fit:cover;
}
</style>